import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

export const Footer = () => {
  const services = [
    { name: 'Trademark Registration', path: '/services/trademark-registration' },
    { name: 'Copyright Registration', path: '/services/copyright-registration' },
    { name: 'Trademark Comprehensive Search', path: '/services/trademark-search' },
    { name: 'Company Formation', path: '/services/company-formation' },
    { name: 'Amazon Brand Registry', path: '/services/amazon-brand-registry' },
  ];

  const company = [
    { name: 'About Us', path: '/about' },
    { name: 'Contact Us', path: '/contact' },
  ];

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-heading font-bold text-white mb-4">
              <img src="/assets/img/brand/logo-light.png" alt="Trademark Law Consulting" className="h-12" />
            </h3>
            <p className="text-slate-400 leading-relaxed">
              Protecting your brand through complete trademark and legal services across the United States.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.path}
                    className="text-slate-400 hover:text-[#E1A334] transition-colors"
                    data-testid={`footer-service-${index}`}
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Company</h4>
            <ul className="space-y-3">
              {company.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.path}
                    className="text-slate-400 hover:text-[#E1A334] transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <div className="flex items-start gap-3 text-slate-400">
                  <Phone className="h-5 w-5 flex-shrink-0 mt-0.5" />
                  <div>
                    <a
                      href="tel:+18777280539"
                      className="hover:text-[#E1A334] transition-colors block"
                    >
                      +1 (877) 728-0539
                    </a>
                  </div>
                </div>
              </li>
              <li>
                <div className="flex items-start gap-3 text-slate-400">
                  <Mail className="h-5 w-5 flex-shrink-0 mt-0.5" />
                  <div>
                    <a
                      href="mailto:info@trademarklawconsulting.com"
                      className="hover:text-[#E1A334] transition-colors block"
                    >
                      info@trademarklawconsulting.com
                    </a>
                  </div>
                </div>
              </li>
              <li>
                <div className="flex items-start gap-3 text-slate-400">
                  <svg className="h-5 w-5 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <div>
                    <p className="leading-relaxed">
                      585 Glenwood Ave, Menlo Park, CA 94025
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 md:px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © 2026 Trademark Law Consulting. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy-policy" className="text-slate-500 hover:text-[#E1A334] transition-colors">
                Privacy Policy
              </Link>
              <span className="text-slate-700">|</span>
              <Link to="/terms-of-service" className="text-slate-500 hover:text-[#E1A334] transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
